import { render, staticRenderFns } from "./OpcionCFDI.vue?vue&type=template&id=4051c55c&scoped=true&"
import script from "./OpcionCFDI.vue?vue&type=script&lang=js&"
export * from "./OpcionCFDI.vue?vue&type=script&lang=js&"
import style0 from "./OpcionCFDI.vue?vue&type=style&index=0&id=4051c55c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4051c55c",
  null
  
)

export default component.exports